/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Action } from "./Action";
export const ApiActionConfig = core.serialization
    .object({
    targetId: core.serialization.string(),
})
    .extend(Action);
